// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ap-0";
export var optionCard = "_ap-1";